import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TypeComponent } from './type.component.js';
import { TypeComponentDirective } from './type-component-directive.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { LayoutModule } from 'src/app/layout/layout.module.js';
import { TypeRoutesModuleConfig } from './type-routes-module.config.js';

@NgModule({
	imports: [CoreModule, LayoutModule, CommonModule],
	providers: [],
	declarations: [TypeComponent, TypeComponentDirective]
})
export class TypeRoutesModule {
	static forRoot(config: TypeRoutesModuleConfig): ModuleWithProviders<TypeRoutesModule> {
		return {
			ngModule: TypeRoutesModule,
			providers: [
				{
					provide: TypeRoutesModuleConfig,
					useValue: config
				}
			]
		};
	}
}
